/**
 * Bottom block of the sidebar: user name + role badge + logout button.
 */

import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { LogOut } from "lucide-react";
import { ROLE_ICON } from "./navItems";

function SidebarUserSectionImpl({ user, collapsed, mobileOpen, onLogout }) {
  const { t } = useTranslation();
  const RoleIcon = ROLE_ICON[user?.role] || ROLE_ICON.super_admin;

  return (
    <div className="border-t border-slate-800 p-3">
      {(!collapsed || mobileOpen) && (
        <div className="mb-2 px-2">
          <p className="text-sm font-medium text-white truncate">{user?.full_name}</p>
          <p className="text-xs text-slate-400 flex items-center gap-1">
            <RoleIcon className="w-3 h-3" />
            {t(`roles.${user?.role}`) || user?.role}
          </p>
        </div>
      )}
      <button
        data-testid="logout-btn"
        onClick={onLogout}
        className="w-full flex items-center gap-3 px-3 py-2 rounded-xl text-sm text-red-400 hover:bg-red-500/10 transition-colors duration-200"
      >
        <LogOut className="w-[18px] h-[18px]" />
        {(!collapsed || mobileOpen) && <span>{t("auth.signOut")}</span>}
      </button>
    </div>
  );
}

const SidebarUserSection = memo(SidebarUserSectionImpl);
export default SidebarUserSection;
